import * as React  from 'react';
import { useState } from 'react';
import {getCsrfToken} from './../../../commons/authenticityToken'

const PER = 10;

const Index = (props) => {
  const [marker, setMarker] = useState(PER);
  // 購入履歴チェックリスト
  const [selectedPurchases, setSelectedPurchases] = useState([]);

  const loadList = () => {
    setMarker(marker + PER);
  }

  const changeCheckBox = () => {
    const element_checkbox = document.querySelectorAll("input[type='checkbox'].cancel_check_box") as NodeListOf<HTMLInputElement>;
    const values = []
    for (let i = 0; i < element_checkbox.length; i++) {
      element_checkbox[i].checked && values.push(element_checkbox[i].value);
    }
    setSelectedPurchases(values);
  }

  return (
    <>
      <h3>購入履歴</h3>
      <br/>
      
        
        <div className="table-responsive">
          <table id="notice_table" className="table table-bordered">
            <thead>
              <tr className="success">
                {props.is_institution_admin &&
                  <th scope="col" className="text-center col-lg-1"></th>
                }
                <th scope="col" className="text-center col-lg-1">発行日</th>
                <th scope="col" className="text-center col-lg-1">有効期限</th>
                <th scope="col" className="text-center col-lg-2">チケット名</th>
                <th scope="col" className="text-center col-lg-1">購入数</th>
                <th scope="col" className="text-center col-lg-1">価格</th>
                <th scope="col" className="text-center col-lg-1">発行枚数</th>
                <th scope="col" className="text-center col-lg-1">消費枚数</th>
                <th scope="col" className="text-center col-lg-1">期限切れ枚数</th>
                <th scope="col" className="text-center col-lg-1">残り枚数</th>
              </tr>
            </thead>
            <tbody>
              {JSON.parse(props.purchases).map((p, i) => (
                <tr key={i} className={selectedPurchases.includes(String(p.id)) && "select-table"}>
                  {　props.is_institution_admin &&
                    <td className="text-center va_middle">
                      { p.is_cancel_possible &&
                        <input id={"checkbox_" + p.id} className="cancel_check_box" type="checkbox" name="cancel_check_box" value={p.id} onChange={changeCheckBox}/>
                      }
                    </td>
                  }
                  <td className="text-center va_middle">{p.converted_purchased_at}</td>
                  <td className="text-center va_middle">{p.converted_expired_at}</td>
                  <td className="text-center va_middle">{p.m_ticket.name}</td>
                  <td className="text-center va_middle">{p.set_count.toLocaleString()}</td>
                  <td className="text-center va_middle">{p.price.toLocaleString()}円</td>
                  <td className="text-center va_middle">{p.init_count.toLocaleString()}枚</td>
                  <td className="text-center va_middle">{p.consumed_count.toLocaleString()}枚</td>
                  <td className="text-center va_middle">{p.expired_count.toLocaleString()}枚</td>
                  <td className="text-center va_middle">{p.remain_count.toLocaleString()}枚</td>
                  

                </tr>
              )).slice(0, marker)}
            </tbody>
          </table>
          <div className="row">
            {
              props.purchase_count > marker
                ? <div className="text-right col-lg-7 col-md-7 col-sm-7 col-xs-7">
                    <button className="btn btn-default more-btn" onClick={loadList}>もっと表示 ▼</button>
                  </div>
                : <div className="text-right col-lg-7 col-md-7 col-sm-7 col-xs-7"/>
            }
            <div className="text-right col-lg-5 col-md-5 col-sm-5 col-xs-5">
              { selectedPurchases.length != 0 &&
                <form name="messages_update_form" action="/tickets/data/cancel_confirm" acceptCharset="UTF-8" method="post">
                  <input name="authenticity_token" type="hidden" value={getCsrfToken()} />
                  <button className="btn btn-danger" type="submit" >キャンセル</button>
                  <input type="hidden" name={"d_purchase_ids"} value={selectedPurchases}/>
                </form>
              }
            </div>
          </div>
        </div>
      
      
     
      {　props.is_institution_admin &&
        <div className="text-right col-lg-12 col-md-12 col-sm-12 col-xs-12">
          ※購入から３営業日以内かつ未使用の場合のみキャンセルの申込が可能です。<br/>
          ※キャンセルの手数料として<b>1,100円(税込)</b>がかかります。
        </div>
      }
    </>
  )
}

export default Index
